import React, { useEffect, useState } from 'react';

const HeroSection = () => {
  const [scrollY, setScrollY] = useState(0);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    
    const handleMouseMove = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('mousemove', handleMouseMove);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  const parallaxX = (mousePosition.x - window.innerWidth / 2) * 0.01;
  const parallaxY = (mousePosition.y - window.innerHeight / 2) * 0.01;

  return (
    <>
      {/* Animated Background Elements */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div 
          className="absolute top-20 right-20 w-96 h-96 bg-orange-100 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob"
          style={{
            transform: `translate(${parallaxX * 2}px, ${parallaxY * 2}px)`
          }}
        ></div>
        <div 
          className="absolute bottom-20 left-20 w-96 h-96 bg-purple-100 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob animation-delay-2000"
          style={{
            transform: `translate(${-parallaxX * 2}px, ${-parallaxY * 2}px)`
          }}
        ></div>
        <div 
          className="absolute top-1/2 left-1/2 w-96 h-96 bg-pink-100 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob animation-delay-4000"
          style={{
            transform: `translate(${parallaxX}px, ${parallaxY}px)`
          }}
        ></div>
      </div>

      <section id="hero" className="min-h-screen relative bg-gradient-to-br from-gray-50 via-gray-100 to-gray-50 overflow-hidden flex items-center justify-center">
        <div className="max-w-[1400px] mx-auto px-8 w-full relative z-10">
          {/* Main Content Container */}
          <div className="relative text-center">
            {/* Top Tagline */}
            <div className="mb-12 animate-slide-down opacity-0" style={{ animationDelay: '0.2s', animationFillMode: 'forwards' }}>
              <p className="text-sm text-gray-800 font-medium tracking-widest uppercase">Multi-Disciplinary Digital Creator</p>
            </div>

            {/* Name Layout - Stacked with 3D effect */}
            <div className="mb-6 perspective-1000 animate-slide-up opacity-0" style={{ animationDelay: '0.4s', animationFillMode: 'forwards' }}>
              <h1 
                className="text-[12vw] md:text-[140px] lg:text-[180px] xl:text-[220px] font-black tracking-tighter leading-none text-black transition-all duration-300 hover:scale-105 cursor-default"
                style={{
                  transform: `perspective(1000px) rotateX(${scrollY * 0.02}deg) rotateY(${parallaxX * 0.5}deg) translate(${parallaxX * 3}px, ${parallaxY * 3}px)`,
                  textShadow: `${parallaxX * 2}px ${parallaxY * 2}px 20px rgba(0,0,0,0.1), 4px 4px 0px rgba(0,0,0,0.05)`,
                  background: 'linear-gradient(135deg, #000 0%, #333 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text'
                }}
              >
                JAGJOT
              </h1>
            </div>

            <div className="mb-8 animate-fade-in opacity-0" style={{ animationDelay: '0.6s', animationFillMode: 'forwards' }}>
              <p className="text-lg md:text-xl text-gray-800 font-medium tracking-wide">Creator & Innovator</p>
            </div>

            <div className="mb-6 perspective-1000 animate-slide-up opacity-0" style={{ animationDelay: '0.8s', animationFillMode: 'forwards' }}>
              <h1 
                className="text-[12vw] md:text-[140px] lg:text-[180px] xl:text-[220px] font-black tracking-tighter leading-none text-black transition-all duration-300 hover:scale-105 cursor-default"
                style={{
                  transform: `perspective(1000px) rotateX(${-scrollY * 0.02}deg) rotateY(${-parallaxX * 0.5}deg) translate(${-parallaxX * 3}px, ${-parallaxY * 3}px)`,
                  textShadow: `${-parallaxX * 2}px ${-parallaxY * 2}px 20px rgba(0,0,0,0.1), 4px 4px 0px rgba(0,0,0,0.05)`,
                  background: 'linear-gradient(135deg, #000 0%, #333 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text'
                }}
              >
                SINGH MAKKAR
              </h1>
            </div>

            {/* Scroll Indicator */}
            <div className="mt-20 animate-bounce">
              <div className="w-6 h-10 border-2 border-gray-300 rounded-full flex items-start justify-center p-2 mx-auto">
                <div className="w-1.5 h-1.5 bg-gray-400 rounded-full animate-scroll-indicator"></div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HeroSection;